import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from 'commons/Text';
import bottomLeft from 'images/bottom_left.svg';
import bottomRight from 'images/bottom_right.svg';
import LogoPlatForm from 'images/logo-platform.svg';
import topLeft from 'images/top_left.svg';
import topRight from 'images/top_right.svg';

import Term from './components/Term';
import useStyles from './styles';

const CertificateBack = ({ downloadMode, language }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const getPageText = () => {
    if (downloadMode === 'both') {
      if (language === 'vi') {
        return t('text_certificate_page_both_vi_back');
      }
      if (language === 'en') {
        return t('text_certificate_page_both_en_back');
      }
    }
    return t('text_certificate_page_2');
  };

  return (
    <Box className={classes.wrapper}>
      <div>
        <Text
          className={classes.textGenerated}
          mb={5}
        >
          {t('generated_by')}
        </Text>
        <img
          src={LogoPlatForm}
          className={classes.logoPlatform}
        />
      </div>

      <Term />

      <img
        src={topLeft}
        alt=""
        className={classes.cornerTopLeft}
      />
      <img
        src={topRight}
        alt=""
        className={classes.cornerTopRight}
      />
      <img
        src={bottomLeft}
        alt=""
        className={classes.cornerBottomLeft}
      />
      <img
        src={bottomRight}
        alt=""
        className={classes.cornerBottomRight}
      />
      <div className={classes.line}></div>
      <p className={classes.text_certificate_page_2}>{getPageText()}</p>
    </Box>
  );
};

export default CertificateBack;
